<h1 mat-dialog-title>
  {{ dialogData.dialogTitle ?? 'pageConfiguration.modalTitle' | translate }}
</h1>
<div mat-dialog-content>
  @for (
    configuration of (dialogData.manager.configurationsSubject | async)?.configurationTabs ?? [];
    track configuration;
    let index = $index
  ) {
    <ng-container [ngSwitch]="configuration.type">
      <app-datatable-page-configuration
        *ngSwitchCase="'datatable'"
        [configuration]="configuration"
        [(uncommittedChanges)]="uncommittedChanges[index]"
      >
      </app-datatable-page-configuration>
    </ng-container>
  }
</div>
<mat-dialog-actions align="end">
  <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
  <button
    *ngIf="(dialogData.manager.configurationsSubject | async)?.isSetAsDefaultAvailable"
    mat-stroked-button
    type="button"
    (click)="apply(true)"
  >
    {{ 'button.setAsDefault' | translate }}
  </button>
  <button mat-flat-button type="submit" (click)="apply(false)">
    {{ 'button.apply' | translate }}
  </button>
</mat-dialog-actions>
